import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(private _http: HttpClient) { }

  login(requestData) {
    return this._http.post(environment.url + "/login", requestData);
  }

  createSocialUser(requestData) {
    return this._http.post(environment.url + "/sociallogin", requestData);
  }

  getOrganizationByCode(code) {
    return this._http.get(environment.url + "/organization/" + code);
  }

  signUp(requestData) {
    return this._http.post(environment.url + "/signup", requestData)
  }

  resetpassword(email: string) {
    return this._http.post(`${environment.url}/user/password/reset`, { email: email });
  }

  changePassword(payload: object) {
    return this._http.put(`${environment.url}/user/password`, payload);
  }
}
